import '.k6{display:inline-block;}.ssr-plugin'
import '.ic{margin-top:1.5rem;}.ssr-plugin'
import '.b8{font-size:0.875rem;}.ssr-plugin'
import '.k7{color:var(--palette-blue-500);}.ssr-plugin'
import '.j4{text-decoration:underline;}.ssr-plugin'
import { useEffect, useState } from 'react'
import { styled } from 'inlines'

export type DiscoveryCrawlerPaginationFooterProps = {
  nextPageHref: string | null
}

export const DiscoveryCrawlerPaginationFooter = ({
  nextPageHref,
}: DiscoveryCrawlerPaginationFooterProps) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!nextPageHref || mounted) {
    return null
  }

  return (
    <a className="k6 ic b8 k7 j4"
      rel="next"
      href={nextPageHref}
    >
      next page
    </a>
  )
}
